// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_c49df8', '__Poppins_Fallback_c49df8'","fontStyle":"normal"},"className":"__className_c49df8"};